import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import { isEmpty } from 'lodash'

import * as actionsAsync from './actionsAsync'
import * as selectors from './selectors'
import { groupsGet } from 'Global/Stores/groups'

const UserDetailModuleHOC = WrappedComponent => {
  class UserDetailModuleHOC extends Component {
    static propTypes = {
      addGroup: PropTypes.func.isRequired,
      changeEmail: PropTypes.func.isRequired,
      changeFirstName: PropTypes.func.isRequired,
      changeLastName: PropTypes.func.isRequired,
      detailUser: PropTypes.object.isRequired,
      error: PropTypes.bool.isRequired,
      getGroups: PropTypes.func.isRequired,
      getUser: PropTypes.func.isRequired,
      groupsOptions: PropTypes.array.isRequired,
      groupsDone: PropTypes.bool.isRequired,
      pending: PropTypes.bool.isRequired,
      removeGroup: PropTypes.func.isRequired,
      resetPassword: PropTypes.func.isRequired,
      router: PropTypes.object.isRequired,
      userGetDone: PropTypes.bool.isRequired,
      userGetError: PropTypes.bool.isRequired,
      userGetPending: PropTypes.bool.isRequired,
    }

    /**
     * Checks whether we already have data in global store.
     * If no data is found, fetches all rugs from the API.
     */
    componentDidMount() {
      const { userId } = this.props.router.params
      const { detailUser, getGroups, getUser, groupsDone, userGetDone } = this.props

      if (!userGetDone || userId !== detailUser.id) {
        getUser(userId)
      }

      if (!groupsDone) {
        getGroups()
      }
    }

    render() {
      const { detailUser, groupsOptions, userGetError, userGetPending } = this.props

      return (
        <WrappedComponent
          groupsOptions={groupsOptions}
          hasError={userGetError}
          isEmpty={isEmpty(detailUser)}
          loaderPending={userGetPending && !userGetError}
          {...this.props}
        />
      )
    }
  }

  const mapStateToProps = (state, ownProps) => ({
    detailUser: selectors.detailUser(state),
    error: selectors.error(state),
    groupsDone: selectors.groupsDone(state),
    groupsOptions: selectors.groupsOptions(state),
    pending: selectors.pending(state),
    userGetDone: selectors.userGetDone(state),
    userGetError: selectors.userGetError(state),
    userGetPending: selectors.userGetPending(state),
  })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    addGroup: (id, group) => dispatch(actionsAsync.groupAdd(id, group)),
    changeEmail: (id, email) => dispatch(actionsAsync.emailChange(id, email)),
    changeFirstName: (id, firstName) => dispatch(actionsAsync.firstNameChange(id, firstName)),
    changeLastName: (id, lastName) => dispatch(actionsAsync.lastNameChange(id, lastName)),
    getGroups: () => dispatch(groupsGet()),
    getUser: id => dispatch(actionsAsync.userGet(id)),
    removeGroup: (id, group) => dispatch(actionsAsync.groupRemove(id, group)),
    resetPassword: id => dispatch(actionsAsync.passwordReset(id)),
  })

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(UserDetailModuleHOC)
}

export default UserDetailModuleHOC
